// extracted by mini-css-extract-plugin
export var avatarContainer = "_8f-0";
export var avatarTypingWave = "_8f-i";
export var gray = "_8f-f";
export var green = "_8f-c";
export var icon = "_8f-9";
export var image = "_8f-1";
export var lg = "_8f-6";
export var md = "_8f-5";
export var presenceDot = "_8f-b";
export var red = "_8f-d";
export var sm = "_8f-4";
export var status = "_8f-a";
export var typingDot = "_8f-h";
export var typingPill = "_8f-g";
export var xl = "_8f-7";
export var xs = "_8f-3";
export var xxl = "_8f-8";
export var xxs = "_8f-2";
export var yellow = "_8f-e";